export default __webpack_public_path__ + "static/media/1.038355f9.png";